import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import AppContext from '@/contexts/appContext';
import PersonContext from '@/pages/Person/PersonContext';
import Button from '@/ui/components/Button';
import { hasPermission, PEOPLE_NEW_DRUG_SCREEN } from '@/utils/userPermission';

const NewDrugScreenButton = () => {
  const { permissions } = useContext(AppContext);
  const { person } = useContext(PersonContext);
  const navigate = useNavigate();
  const isAllowedNewDrugScreen = hasPermission({
    permissions,
    requiredPermission: PEOPLE_NEW_DRUG_SCREEN
  });

  return (
    <>
      {isAllowedNewDrugScreen && (
        <Button onClick={() => navigate(`/people/${person.id}/drug-screens/new`)}>
          New Ad Hoc Drug Screen
        </Button>
      )}
    </>
  );
};

export default NewDrugScreenButton;
